<div class="form__validation d-flex align-items-center mb-3 bg-gray-300">
    <wdx-icon
        class="form__validation__icon icon-shift-up"
        icon="info-circle"
        [scale]="1"
    >
    </wdx-icon>
    <ng-content></ng-content>
</div>
